import { ClassType } from '@lingoda/graphql';
import minBookingDateSelector from './minBookingDate';

export default minBookingDateSelector(ClassType.Individual);
